import { render, staticRenderFns } from "./sorting-attribute.vue?vue&type=template&id=12a2f23a&"
import script from "./sorting-attribute.vue?vue&type=script&lang=js&"
export * from "./sorting-attribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports